import React from "react";
import { makeStyles } from "@material-ui/core";
import { ReactComponent as Loader } from "../../../../images/analytics/ChartLoader.svg";
import { EmptyChart } from "../../components/EmptyChart";

/* ---------------- STYLES ---------------- */

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",

    // ✅ layered background (texture + gradient)
    backgroundColor:"white",

    border: "2px solid rgba(180,107,130,0.15)",
    borderRadius: "16px",
    padding: "18px 20px",

    // ✅ soft shadow
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    transition: "all 0.2s ease",

    "&:hover": {
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    },

    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },

  headingContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",

    borderBottom: "1px solid #f1f5f9",
    paddingBottom: "8px",

    "& > h3": {
      fontSize: "16px",
      fontWeight: 700,
      color: "#111827",
      margin: 0,
      lineHeight: 1.3,
    },

    "& > p": {
      fontSize: "12px",
      color: "#6b7280",
      margin: 0,
    },
  },

  content: {
    width: "100%",
    flex: 1,
  },

  "@media (max-width: 768px)": {
    container: {
      padding: "14px",
      borderRadius: "14px",
    },
  },

  "@media (max-width: 480px)": {
    container: {
      padding: "12px",
      borderRadius: "12px",
      margin: "8px 0",
    },

    headingContainer: {
      "& > h3": {
        fontSize: "14px",
      },
      "& > p": {
        fontSize: "11px",
      },
    },
  },
}));

/* ---------------- COMPONENT ---------------- */

export function ChartWrapper({
  loading,
  isEmpty,
  title,
  description,
  children,
}) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {/* HEADER */}
      <div className={classes.headingContainer}>
            <h3>{title}</h3>
            {description && <p>{description}</p>}
          </div>
      {isEmpty ? (
        <EmptyChart />
      ) : (
        <>
          
          {loading ? (
            <Loader />
          ) : (
            <div style={{ width: "100%", height: "370px" }}>{children}</div>
          )}
        </>
      )}
    </div>
  );
}
